import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Messages } from 'primereact/messages';
import { Message } from 'primereact/message';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import axiosClient, { useQuery } from '../constants';
import '../styles/_ResetPassword.css';
const ResetPassword = () => {
    const query = useQuery();
    const hash = query.get('hash')
    const { userId } = useParams();
    const [linkStatus, setLinkStatus] = useState('');
    const [message, setMessage] = useState('');
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [passwordValid, setPasswordValid] = useState(true);
    const [confirmPasswordValid, setConfirmPasswordValid] = useState(true);
    const messages = useRef(null);
    const resetPassword = () => {
        axiosClient.put("/forget-change-password", {
            userId,
            password: newPassword
        }).then(res => {
                      console.log('inside reset password')
                      console.log(res.data.error)
                      if (res.data.error) {
                          setMessage({ severity: 'error', message: res.data.message });
                      }
                      else {
                          setMessage({ severity: 'info', message: res.data.message });
                          setTimeout(() => {
                                             window.location.href = '#/login'
                                }, 2000)
                      }

                  }).catch(err => {
                      setMessage({ severity: 'error', message: "Password could not be changed because of a system error!" });

                  });
            };

    useEffect(() => {
        console.log('Inside useeffect');
        axiosClient.get(`/verify-reset-password-link/${userId}/${hash}`)
            .then(res => {
                if (res.data !== 'Success') {
                    setLinkStatus(res.data)
                }
            }).catch(console.error)
    }, [hash, userId])
    useEffect(() => {
        if (newPassword.length > 0 && newPassword.length < 8) {
            setPasswordValid(false);
        } else {
            setPasswordValid(true);

        }
        if (confirmPassword.length && confirmPassword !== newPassword) {
            setConfirmPasswordValid(false)
        } else {
            setConfirmPasswordValid(true)

        }
    }, [newPassword, confirmPassword]);
    return <div>
        <div className="app-topbar">
            <img alt="Logo" src="assets/layout/images/l.png" className="topbar-logo" />
        </div>
        <div className="main-container">
            <div className="main-content">
                <h1>Reset password</h1>
                <br /><br />
                                {message
                                    &&
                                    <>
                                        <Message severity={message.severity} text={message.message} ></Message>
                                        <br />
                                    </>
                                }
                {
                    linkStatus.length > 0
                        ?
                        <p>{linkStatus}</p>
                        :
                        <div>
                            <div className="input-container">
                                <div>New Password</div>
                                <InputText value={newPassword} onChange={(e) => setNewPassword(e.target.value)} type="password" />
                                {!passwordValid && <small>Password should be atleast 8 characters</small>}
                            </div>
                            <div className="input-container">
                                <div>Confirm Password</div>
                                <InputText value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} type="password" />
                                {!confirmPasswordValid && <small>Passwords don't match</small>}

                            </div>
                            <Button disabled={newPassword.length===0 || confirmPassword.length === 0 || !confirmPasswordValid || !passwordValid} onClick={resetPassword} label={'Change Password'} ></Button>
                        </div>
                }

            </div>
        </div>
    </div>
}
export default ResetPassword;